import React from "react";

import { Backdrop, CircularProgress } from "@mui/material";

export const Loading = (): JSX.Element => (
  <Backdrop sx={{ color: "#f3f2f1", zIndex: (theme) => theme.zIndex.drawer + 1 }} open>
    <CircularProgress color="inherit" />
  </Backdrop>
);
